import { type ReactNode, Suspense } from "react";
import { HelmetProvider } from "react-helmet-async";
import { AppThemeProvider } from "@/src/common/contexts/theme-provider";

interface AppProps {
	children: ReactNode;
}

export function App({ children }: AppProps) {
	return (
		<HelmetProvider>
			<AppThemeProvider>
				<Suspense fallback={null}>{children}</Suspense>
			</AppThemeProvider>
		</HelmetProvider>
	);
}
